import { t } from '@lingui/core/macro';

import AnalyticsMenuIcon from '@/assets/svg/bx-bar-chart-alt.svg?react';
import PixelsMenuIcon from '@/assets/svg/bx-broadcast.svg?react';
import AudiencesMenuIcon from '@/assets/svg/bx-buildings-alt.svg?react';
import SettingsMenuIcon from '@/assets/svg/bx-cog.svg?react';
import DashboardMenuIcon from '@/assets/svg/bx-customize.svg?react';
import OpportunityMenuIcon from '@/assets/svg/bx-dollar-circle.svg?react';
import ChannelsMenuIcon from '@/assets/svg/bx-network-chart.svg?react';
import PaidSearchMenuIcon from '@/assets/svg/bx-search-paid.svg?react';
import AIVisibilityMenuIcon from '@/assets/svg/bx-show-alt.svg?react';
import VendorsMenuIcon from '@/assets/svg/bx-vendors.svg?react';
import CampaignMenuIcon from '@/assets/svg/megaphone.svg?react';
import Icon from '@/components/icon';
import { FEATURE_FLAG } from '@/constants/featureFlags';
import { ROUTES } from '@/router';

import { type MenuItemTypeCallback } from './types';

export const getMenuItems: MenuItemTypeCallback = () => [
  {
    type: 'item',
    key: ROUTES.dashboard.path,
    icon: <Icon icon={DashboardMenuIcon} />,
    label: t`Dashboard`,
  },
  {
    type: 'item',
    key: ROUTES.aiVisibility.path,
    icon: <Icon icon={AIVisibilityMenuIcon} />,
    label: t`AI Visibility`,
    hidden: (flags) => !flags[FEATURE_FLAG.aiVisibility],
  },
  {
    type: 'submenu',
    key: 'analytics',
    icon: <Icon icon={AnalyticsMenuIcon} />,
    label: t`Analytics`,
    children: [
      {
        type: 'item',
        key: ROUTES.webTraffic.path,
        label: t`Web Traffic`,
      },
      {
        type: 'item',
        key: ROUTES.webTrafficActivity.path,
        label: t`Activity`,
      },
      {
        type: 'item',
        key: ROUTES.attribution.path,
        label: t`Attribution`,
      },
      {
        type: 'item',
        key: ROUTES.webTrafficBenchmarks.path,
        label: t`Benchmarks`,
      },
    ],
  },
  {
    type: 'item',
    key: ROUTES.channels.path,
    icon: <Icon icon={ChannelsMenuIcon} />,
    label: t`Channels`,
  },
  {
    type: 'item',
    key: ROUTES.vendors.path,
    icon: <Icon icon={VendorsMenuIcon} />,
    label: t`Vendors`,
  },
  {
    type: 'item',
    key: ROUTES.campaigns.path,
    icon: <Icon icon={CampaignMenuIcon} />,
    label: t`Campaigns`,
  },
  {
    type: 'item',
    key: ROUTES.paidSearchByType('adGroup'),
    icon: <Icon icon={PaidSearchMenuIcon} />,
    label: t`Paid Search`,
  },
  {
    type: 'item',
    key: ROUTES.opportunities.path,
    icon: <Icon icon={OpportunityMenuIcon} />,
    label: t`Opportunities`,
  },
  {
    type: 'item',
    key: ROUTES.pixels.path,
    icon: <Icon icon={PixelsMenuIcon} />,
    label: t`Pixels`,
    isPaid: true,
  },
  {
    type: 'item',
    key: ROUTES.audiences.path,
    icon: <Icon icon={AudiencesMenuIcon} />,
    label: t`Audiences`,
    isPaid: true,
  },
  {
    type: 'submenu',
    key: 'settings',
    icon: <Icon icon={SettingsMenuIcon} />,
    label: t`Settings`,
    children: [
      {
        type: 'item',
        key: ROUTES.healthCenter.path,
        label: t`Health Center`,
      },
      {
        type: 'item',
        key: ROUTES.configureVendors.path,
        label: t`Vendor Spend`,
        isAdmin: true,
      },
      {
        type: 'item',
        key: ROUTES.configureChannels.path,
        label: t`Channel Mapping`,
        isAdmin: true,
      },
      {
        type: 'item',
        key: ROUTES.integrations.path,
        label: t`Integrations`,
        isAdmin: true,
      },
      {
        type: 'item',
        key: ROUTES.companySettings.path,
        label: t`Your Company`,
        isAdmin: true,
      },
      {
        type: 'item',
        key: ROUTES.users.path,
        label: t`Users & Roles`,
        isAdmin: true,
      },
      {
        type: 'item',
        key: ROUTES.eventLog.path,
        label: t`Event Log`,
        isAdmin: true,
      },
    ],
  },
];
